import React, { useState, useEffect } from 'react';
import { API_URL } from '../../services/api';
import {
  Grid,
  Paper,
  Typography,
  Box,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
  Chip
} from '@mui/material';

import ArticleIcon from '@mui/icons-material/Article';
import MicIcon from '@mui/icons-material/Mic';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import axios from 'axios';

interface DashboardStats {
 totalNews: number;
 publishedNews: number;
 totalDjs: number;
 totalPrograms: number;
}

interface RecentNews {
 id: number;
 title: string;
 author_name: string;
 created_at: string;
}

interface PopularNews {
 title: string;
 slug: string;
 views: number;
}

const AdminDashboard: React.FC = () => {
 const [stats, setStats] = useState<DashboardStats>({
 totalNews: 0,
 publishedNews: 0,
 totalDjs: 0,
 totalPrograms: 0});
 const [recentNews, setRecentNews] = useState<RecentNews[]>([]);
 const [popularNews, setPopularNews] = useState<PopularNews[]>([]);

 useEffect(() => {
 fetchDashboardData();
 }, []);

 const fetchDashboardData = async () => {
 try {
 const token = localStorage.getItem('token');
 const response = await axios.get(`${API_URL}/api/admin/dashboard`, {
 headers: { Authorization: `Bearer ${token}` }});
 setStats(response.data.stats);
 setRecentNews(response.data.recentNews);
 setPopularNews(response.data.popularNews);
 } catch (error) {
 console.error('Error fetching dashboard data:', error);
 }
 };

 const formatDate = (dateString: string) => {
 const date = new Date(dateString);
 return date.toLocaleDateString('es-ES');
 };

 const statCards = [
 {
 title: 'Total Noticias',
 value: stats.totalNews,
 icon: <ArticleIcon />,
 color: '#2196f3'},
 {
 title: 'Publicadas',
 value: stats.publishedNews,
 icon: <PublishedWithChangesIcon />,
 color: '#4caf50'},
 {
 title: 'DJs',
 value: stats.totalDjs,
 icon: <MicIcon />,
 color: '#ff9800'},
 {
 title: 'Programas',
 value: stats.totalPrograms,
 icon: <CalendarMonthIcon />,
 color: '#9c27b0'},
 ];

 return (
 <>
 <Typography variant="h4" sx={{ mb: 4, fontWeight: 600 }}>
 Dashboard
 </Typography>

 <Grid container spacing={3}>
 {statCards.map((card, index) => (
 <Grid key={index} item xs={12} sm={6} md={3}>
 <Card
 sx={{
 background: 'linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)'}}
 >
 <CardContent>
 <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
 <Box
 sx={{
 display: 'flex',
 alignItems: 'center',
 justifyContent: 'center',
 width: 50,
 height: 50,
 borderRadius: '50%',
 bgcolor: card.color,
 color: 'white'}}
 >
 {card.icon}
 </Box>
 <Box sx={{ ml: 2 }}>
 <Typography variant="h4" sx={{ fontWeight: 700 }}>
 {card.value}
 </Typography>
 <Typography variant="body2" color="text.secondary">
 {card.title}
 </Typography>
 </Box>
 </Box>
 </CardContent>
 </Card>
 </Grid>
 ))}

 <Grid item xs={12} md={6}>
 <Paper
 sx={{
 p: 3,
 height: '100%',
 background: 'linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)'}}
 >
 <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
 Noticias Recientes
 </Typography>
 <List>
 {recentNews.map((news) => (
 <ListItem key={news.id} sx={{ px: 0 }}>
 <ListItemText
 primary={news.title}
 secondary={
 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
 <Chip
 label={news.author_name}
 size="small"
 color="primary"
 />
 <Typography variant="caption" color="text.secondary">
 {formatDate(news.created_at)}
 </Typography>
 </Box>
 }
 />
 </ListItem>
 ))}
 </List>
 </Paper>
 </Grid>

 <Grid item xs={12} md={6}>
 <Paper
 sx={{
 p: 3,
 height: '100%',
 background: 'linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)'}}
 >
 <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
 <TrendingUpIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
 Noticias Más Vistas
 </Typography>
 <List>
 {popularNews.map((news, index) => (
 <ListItem key={index} sx={{ px: 0 }}>
 <ListItemText
 primary={news.title}
 secondary={
 <Typography variant="caption" color="primary">
 {news.views} vistas
 </Typography>
 }
 />
 </ListItem>
 ))}
 </List>
 </Paper>
 </Grid>
 </Grid>
 </>
 );
};

export default AdminDashboard;